export const enum Language {
  EN = 'en',
  ES = 'es',
  PT = 'pt',
  FR = 'fr',
  DE = 'de',
  JA = 'ja',
  KO = 'ko',
  PL = 'pl',
  TR = 'tr',
  AR = 'ar',
  IT = 'it',
  CS = 'cs',
  HU = 'hu',
}

export const LANGUAGE_STRIPE_LOCALE_MAP = {
  [Language.EN]: 'GB',
  [Language.ES]: 'ES',
  [Language.PT]: 'PT',
  [Language.FR]: 'FR',
  [Language.DE]: 'DE',
  [Language.JA]: 'JP',
  [Language.KO]: 'GB',
  [Language.PL]: 'PL',
  [Language.TR]: 'GB',
  [Language.AR]: 'GB',
  [Language.IT]: 'IT',
  [Language.CS]: 'CZ',
  [Language.HU]: 'HU',
}

export const SUPPORTED_LOCALES: string[] = [
  Language.EN,
  Language.KO,
  Language.PL,
  Language.TR,
  Language.JA,
  Language.PT,
  Language.ES,
  Language.AR,
  Language.IT,
  Language.DE,
  Language.FR,
  Language.CS,
  Language.HU,
]
export const RTL_LOCALES: string[] = [Language.AR]
export const INITIAL_LANGUAGE = Language.EN
export const LANG_QUERY_PARAM = 'lang'
